import { forwardRef } from 'react'
import type { ItemProps } from 'react-virtuoso'

import type { VirtualListItem } from './Context'
import type Context from './Context'

const Item = forwardRef(function <T extends VirtualListItem>(
  { context, ...props }: ItemProps<T> & { context?: Context<T> },
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const role = context?.list && context?.list.role === 'grid' ? 'row' : 'listitem'
  return <div {...props} ref={ref} role={role} />
})

export default Item
